import { Grid, Typography } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import React from 'react';

const grandSeperator = val => {
	if(!val) {
		return "0"
	}
	
	val = val
		.toString()
		.replace(/,/g, '')
		.replace(/ /g, '');
	let parsed = parseInt(val);

	if (!isNaN(parsed)) {
		return parsed.toLocaleString().replace(/,/g, ' ');
	} else {
		return val;
	}
};

const EmptyRow = props => (
	<GridItem xs={12} sm={12} md={12}>
		<Typography style={{ paddingTop: '5px', color: 'white' }}>R</Typography>
	</GridItem>
);

const customRow = (firstCol, secondCol, thirdCol) => {
	return (
	  <React.Fragment>
		<Grid item xs={12} sm={12} md={12}>
		  <Grid container>
			<GridItem xs={3} sm={3} md={3}>
			  {firstCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {secondCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {thirdCol}
			</GridItem>
			<GridItem xs={5} sm={5} md={5}>
			  
			</GridItem>
		  </Grid>
		</Grid>
	  </React.Fragment>
	);
  };

const Accrual = props => {
	const accrual = props.state.result.accrual;

	return (
		<React.Fragment>
			<Grid container className="fnaGridHeading">
				<GridItem xs={6} sm={6} md={6}>
					<Typography variant="subheading">
						<strong>Accrual</strong>
					</Typography>
				</GridItem>

				<GridItem xs={3} sm={3} md={3}>
					<Typography variant="subheading">
						<strong>Client</strong>
					</Typography>
				</GridItem>
				<GridItem item xs={3} sm={3} md={3}>
					<Typography variant="subheading">
						<strong>Spouse</strong>
					</Typography>
				</GridItem>
			</Grid>
			<Grid direction="column" className="fnaGridBody">
				<Grid item xs={12} sm={12} md={12}>
					<Grid container className="fnaGridBodyRow">
						<GridItem xs={12} sm={12} md={12}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								<strong>Current:</strong>
							</Typography>
						</GridItem>

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								Current value of assets
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.current.valueOfAssets.client.toString()
								)}
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.current.valueOfAssets.spouse.toString()
								)}
							</Typography>
						</GridItem>

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								Plus Policies to estate
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.current.valueOfPolicies.toString()
								)}
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								
							</Typography>
						</GridItem>

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								Minus Liabilities
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.current.minusLiabilities.client.toString()
								)}
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.current.minusLiabilities.spouse.toString()
								)}
							</Typography>
						</GridItem>

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								Nett value
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								<strong>
									R{' '}
									{grandSeperator(accrual.current.netValue.client.toString())}
								</strong>
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								<strong>
									R{' '}
									{grandSeperator(accrual.current.netValue.spouse.toString())}
								</strong>
							</Typography>
						</GridItem>

						<EmptyRow />

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								<strong>Asset value excluded from accrual</strong>
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								<strong>
									R{' '}
									{grandSeperator(
										accrual.assetValueExcluded.client.toString()
									)}
								</strong>
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								<strong>
									R{' '}
									{grandSeperator(
										accrual.assetValueExcluded.spouse.toString()
									)}
								</strong>
							</Typography>
						</GridItem>

						<EmptyRow />

						<GridItem xs={12} sm={12} md={12}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								<strong>At marriage:</strong>
							</Typography>
						</GridItem>

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								Value according to ANC
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.atMarriage.valueANC.client.toString()
								)}
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								{grandSeperator(
									accrual.atMarriage.valueANC.spouse.toString()
								)}
							</Typography>
						</GridItem>

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								Current value (CPI adjusted)
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								N/A
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								R{' '}
								N/A
							</Typography>
						</GridItem>

						<EmptyRow />

						<GridItem xs={6} sm={6} md={6}>
							<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
								<strong>Accrual</strong>
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								<strong>
									R {grandSeperator(accrual.netAccrual.client.toString())}
								</strong>
							</Typography>
						</GridItem>
						<GridItem xs={3} sm={3} md={3}>
							<Typography style={{ paddingTop: '5px' }}>
								<strong>
									R {grandSeperator(accrual.netAccrual.spouse.toString())}
								</strong>
							</Typography>
						</GridItem>

						
					</Grid>
					
				</Grid>
				
			</Grid>
			{customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "25px" }}>
            <strong>Claim against spouse</strong>
          </Typography>,
          <Typography style={{ paddingTop: "25px" }}>
            <strong>
									R{' '}
									{grandSeperator(
										accrual.claimAgainstSpouse.toString()
									)}
								</strong>
          </Typography>,
          null
        )}
			{customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Claim by spouse</strong>
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            <strong>
									R{' '}
									{grandSeperator(
										accrual.clainBySpouse.toString()
									)}
								</strong>
          </Typography>,
          null
        )}
		</React.Fragment>
	);
};

export default Accrual;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/Accrual.jsx